<template>
    <div class="contain">

        <div class="col-sm-8 col-xs-22" style="position: relative; text-align: center">
            <div style="margin: 2rem 0 1rem" class="back-button cursor-pointer" @click="onBack">
                <i class="el-icon-back" style="margin-right: 0.25rem"></i>
                <div style="text-align: left">
                    {{ `返回${isRenew ? "續訂" : "訂閱"} Back` }}
                </div>
            </div>
          <div style="margin: 5rem 0 1rem">
            {{ token == null ? "第 3 步，共 3 步 | Step 3 ,  Total 3 steps " : "第 2 步，共 2 步 | Step 2 ,  Total 2 steps " }}
          </div>
            <div style="font-size: 2rem; line-height: 2rem; font-weight: bold; color: #b62d2e; white-space: pre-wrap">
                {{ "結帳\n Checkout" }}
            </div>
        </div>
        <div style="display: flex; margin-top: 0.5rem; margin-bottom: 1rem">
            <span style="width: 1rem; height: 1rem; background: #b62d2e; border-radius: 50%; margin: 0 0.5rem"></span>
            <span style="width: 1rem; height: 1rem; background: #de5934; border-radius: 50%; margin: 0 0.5rem"></span>
            <span style="width: 1rem; height: 1rem; background: #f1aa55; border-radius: 50%; margin: 0 0.5rem"></span>
        </div>
        <div>信用卡付款</div>
        <div>Credit card payment</div>
        <form id="payment-form" class="col-sm-8 col-xs-22" style="margin-top: 20px">
            <div id="payment-element"></div>
            <div style="display: flex; flex-direction: column; margin-top: 5rem">
                <el-button round @click="handleSubmit" class="security-button">完成 Confirm</el-button>
            </div>
        </form>
    </div>
</template>

<script>
import { loadStripe } from "@stripe/stripe-js";
import { payRequest } from "@/api/order";
export default {
    data() {
        return {
            orderId: null,
            elements: null,
            stripe: null,
            isRenew: false,
        };
    },
    created() {
        if (!this.isEmpty(this.$route.query.orderId)) {
            this.orderId = this.$route.query.orderId;
        }
        if (!this.isEmpty(this.$route.query.isRenew) && this.$route.query.isRenew === "true") {
            this.isRenew = true;
        }
        this.initialize();
        //  this.payRequest()
    },
    watch: {
        "$store.getters.language": {
            handler() {
                this.elements.update({ locale: this.$store.getters.language == "en" ? "en" : "zh-HK" });
                this.$forceUpdate();
            },
            deep: true,
        },
    },
    methods: {
        async initialize() {
            this.stripe = await loadStripe("pk_live_51L0HUaI8vOrdPKKT8Rs8n8B6kq0siShB5AEsP0K7bADZYXYOIBTgwsm7lxfuNJZWyqojDlQmGHo5eko1oX0Ti8BF005s8QX9hn");
            this.payRequest(this.stripe);
        },
        payRequest(stripe) {
            payRequest(this.orderId).then((v) => {
                // const appearance = {
                //     rules: {
                //         ".Label": {
                //             color: "blue",
                //             fontSize: "1rem",
                //             lineHeight: "1.6rem",
                //         },
                //     },
                // };
                this.elements = stripe.elements({
                    clientSecret: v.data.clientCecret,
                    locale: this.$store.getters.language == "en" ? "en" : "zh-HK",
                });
                this.elements.update({ currency: "hkd" });
                // const options = {
                //   defaultValues:{
                //     billingDetails:{
                //       name:'123456'
                //     }
                //   },
                //   fields:{
                //     billingDetails:{
                //       name:"auto",
                //       address:{
                //         country:"never"
                //       }
                //     }
                //   }
                // };
                const paymentElement = this.elements.create("payment");
                paymentElement.mount("#payment-element");
            });
        },
        async handleSubmit(e) {
          console.info(`${window.location.origin}/index.html#/checkout?orderId=${this.orderId}&isRenew=${this.isRenew}&isSubscribe=${this.token != null}`)
            e.preventDefault();
            var result = await this.stripe.confirmPayment({
                elements: this.elements,
                confirmParams: {
                    // return_url: `${process.env.VUE_APP_URL}/index.html#/checkout?orderId=${this.orderId}&isRenew=${this.isRenew}&isSubscribe=${this.token!=null}`,
                    return_url: `${window.location.origin}/index.html#/checkout?orderId=${this.orderId}&isRenew=${this.isRenew}&isSubscribe=${this.token != null}`,
                },
            });
            if (result.error && result.error.type == "card_error") {
                this.$router.push({
                    path: "/checkout",
                    query: {
                        orderId: this.orderId,
                        isRenew: this.isRenew,
                        isSubscribe: this.token != null,
                        isFail: true,
                    },
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.contain {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.back-button {
    position: absolute;
    left: 0;
    display: flex;
}
.security-button {
    margin: 1.25rem 0;
    border: 0.0625rem solid #fcc03a;
    font-weight: bold;
    font-size: 1.125rem;
    color: #444444;
    background-color: #fcc03a;
}
.label {
    margin-bottom: 4px;
    font-size: 0.93rem;
    transition: transform 0.5s cubic-bezier(0.19, 1, 0.22, 1), opacity 0.5s cubic-bezier(0.19, 1, 0.22, 1);
}
.field {
    border: 1px solid #e6e6e6;
    padding: 12px;
}

@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
    .back-button {
        position: static;
        text-align: left;
    }
}
</style>
